import script from "./ReportarDuvida.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportarDuvida.vue?vue&type=script&setup=true&lang=js"

import "./ReportarDuvida.vue?vue&type=style&index=0&id=65bb90e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65bb90e8"]])

export default __exports__